module.exports = "/images/request_vehicle_regis_white.svg?c387346ec79468767cebaa83a197c74e";